import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import styles from "./PreviewFlyers.scss";
import Loading from "../../utils/loading/Loading";
import axios from "axios";
import { Env } from "../../../env";

class PreviewFlyers extends Component {
  static propTypes = {
    route: PropTypes.objectOf(PropTypes.any).isRequired,
    admin: PropTypes.shape({
      requesting: PropTypes.bool.isRequired,
      successful: PropTypes.bool.isRequired,
      error: PropTypes.String,
      user: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
      }),
      modalCovid: true,
    }).isRequired,
  };

  constructor(props) {
    super(props);
    this.bottomBarDomElem = React.createRef();
    this.state = {
      specialities: "",
      loader: true,
    };
  }

  componentDidMount() {
    this.getSpecialities();
    console.log("VV");
    // this.checkModalCovid();
  }

  getSpecialities = async () => {
    try {
      let spec = this.props.admin.user.specialityId;
      const specialities = await axios.get(
        `${Env.BASE_API_URL}/Specialities/${spec}`
      );
      if (specialities && specialities.data.name) {
        // Wait before write in specialities
        setTimeout(() => {
          this.setState({
            specialities: specialities.data.name,
            loader: false,
          });
        }, 1500);
      }
    } catch (error) {
      console.log("error ", error);
    }
  };

  checkModalCovid = () => {
    if (!localStorage.getItem("modalCovid")) {
      console.log("AAAA");
      this.setState({
        modalCovid: false,
      });
    }
  };

  render() {
    var h = window.location.href;
    var baseUrl =
      h.includes("localhost") || h.includes("127.0.0.1")
        ? "http://localhost:3001"
        : Env.BASE_API_URL;

    console.log("ADMIN: ", this.props.admin);
    const firstName = this.props.admin.user.firstName;
    console.log("firstName : ", firstName);
    const lastName = this.props.admin.user.lastName;
    console.log("lastName : ", lastName);
    const subDomain = this.props.admin.user.subdomain;
    console.log("subdomain : ", subDomain);
    const postalAddress = this.props.admin.user.postaladdress;
    console.log("postaladdress : ", postalAddress);
    const idUser = this.props.admin.user.id;
    console.log("idUser : ", idUser);
    const doctorName = firstName + " " + lastName;
    console.log("DoctorName : ", doctorName);
    const speciality = this.state.specialities;
    console.log("spec : ", speciality);
    return (
      <div>
        {this.state.loader && <Loading size={80} />}
        {!this.state.loader && (
          <div id={styles.containerIframe}>
            {/* <iframe  frameBorder="0" src="http://localhost:8080/" width="100%" height="100%" ></iframe> */}
            <iframe
              id={styles.FlyerIframe}
              src={`${baseUrl}/flyer?idUser=${idUser}&doctorName=${doctorName}&subDomain=${subDomain}&speciality=${speciality}&postalAddress=${postalAddress}`}
              frameBorder="0"
              height="100%"
              width="100%"
            ></iframe>
          </div>
        )}
        {/* {!this.state.modalCovid && !this.state.loader &&
                    <div className={styles.containerModalCovid}>
                        <img src="assets/img/DD-logo-long-noir.png" className={styles.imgModalCovid}></img>
                        <h2 className={styles.titleModalCovid}>Informations Covid-19 Digidocteur</h2>
                        <p className={styles.textModalCovid}>En raison de l'épidémie de Covid 19, nous déconseillons l'usage des flyers papiers en salle d'attente. Toutefois, si vous souhaitez les remettre en fin de consultation pour un visionnage en replay, merci de nous contacter :</p>
                        <a className={styles.btnEmailModal} href="mailto:contact@digidocteur.com">contact@digidocteur.com</a>
                    </div>
                } */}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  admin: state.admin,
});

export default connect(mapStateToProps, {})(PreviewFlyers);



// WEBPACK FOOTER //
// ./src/pages/admin/Flyers/PreviewFlyers.jsx